export default __webpack_public_path__ + "static/B0155-df1c1c671d84f846a279a6e36de78736.png";